import { QUESTION_TYPES } from '../../../features/quizzes/lib/quizTypes';

/** @typedef {{ grade: number, disk_num: number, label?: string }} AudioposobieLink */

export const QUIZZES = [
    {
        id: 'guess-composer',
        title: 'Угадай композитора',
        emoji: '🎼',
        tagline: 'Кто написал это произведение?',
        duration: '~8 мин',
        color: '#5b8def',
        listenLink: null,
        questions: [
            {
                type: QUESTION_TYPES.MULTIPLE_CHOICE,
                prompt: 'Кто написал цикл «Картинки с выставки»?',
                options: ['Мусоргский', 'Чайковский', 'Бах', 'Моцарт'],
                correctIndex: 0,
                explanation: 'Модест Мусоргский. Послушай в Аудиопособии — 4 класс.',
                listenLink: { grade: 4, disk_num: 3, label: '4 класс, раздел 3' },
            },
            {
                type: QUESTION_TYPES.MULTIPLE_CHOICE,
                prompt: 'Балет «Щелкунчик» с танцем «Трепак» — это…',
                options: ['Чайковский', 'Прокофьев', 'Глинка', 'Римский-Корсаков'],
                correctIndex: 0,
                explanation: 'Пётр Ильич Чайковский. Есть в 4 классе.',
                listenLink: { grade: 4, disk_num: 2, label: '4 класс, раздел 2' },
            },
            {
                type: QUESTION_TYPES.MULTIPLE_CHOICE,
                prompt: '«Детский альбом» для фортепиано написал…',
                options: ['Чайковский', 'Бах', 'Шопен', 'Лист'],
                correctIndex: 0,
                explanation: 'Чайковский любил писать музыку для детей.',
                listenLink: { grade: 4, disk_num: 1, label: '4 класс, раздел 1' },
            },
            {
                type: QUESTION_TYPES.MULTIPLE_CHOICE,
                prompt: 'Прелюдия до мажор из «ХТК» — произведение…',
                options: ['Баха', 'Гайдна', 'Моцарта', 'Бетховена'],
                correctIndex: 0,
                explanation: 'Иоганн Себастьян Бах. Слушай в 4 классе.',
                listenLink: { grade: 4, disk_num: 1, label: '4 класс, раздел 1' },
            },
            {
                type: QUESTION_TYPES.MULTIPLE_CHOICE,
                prompt: 'Опера «Орфей» принадлежит…',
                options: ['Монтеверди', 'Вагнеру', 'Верди', 'Пуччини'],
                correctIndex: 0,
                explanation: 'Клаудио Монтеверди — ранний барокко. В пособии — 4 класс, раздел 1 (Глюк «Орфей»).',
                listenLink: { grade: 4, disk_num: 1, label: '4 класс, раздел 1' },
            },
            {
                type: QUESTION_TYPES.MULTIPLE_CHOICE,
                prompt: '«Страсти по Матфею» написал…',
                options: ['И. С. Бах', 'Гендель', 'Шуберт', 'Брамс'],
                correctIndex: 0,
                explanation: 'Иоганн Себастьян Бах — великий немецкий композитор.',
                listenLink: { grade: 5, disk_num: 1, label: '5 класс, раздел 1' },
            },
            {
                type: QUESTION_TYPES.MULTIPLE_CHOICE,
                prompt: 'Симфония №3 «Божественная поэма» — это…',
                options: ['Скрябин', 'Рахманинов', 'Бородин', 'Балакирев'],
                correctIndex: 0,
                explanation: 'Александр Николаевич Скрябин. 7 класс.',
                listenLink: { grade: 7, disk_num: 1, label: '7 класс, раздел 1' },
            },
            {
                type: QUESTION_TYPES.MULTIPLE_CHOICE,
                prompt: 'Балет «Петрушка» написал…',
                options: ['Стравинский', 'Чайковский', 'Глазунов', 'Лядов'],
                correctIndex: 0,
                explanation: 'Игорь Фёдорович Стравинский.',
                listenLink: { grade: 7, disk_num: 3, label: '7 класс, раздел 3' },
            },
        ],
    },
    {
        id: 'russian-heroes',
        title: 'Русские музыкальные герои',
        emoji: '⭐',
        tagline: 'Знаменитые русские композиторы',
        duration: '~10 мин',
        color: '#9b59b6',
        listenLink: { grade: 7, disk_num: 1, label: '7 класс' },
        questions: [
            {
                type: QUESTION_TYPES.MULTIPLE_CHOICE,
                prompt: 'Кто написал оперу «Евгений Онегин»?',
                options: ['Чайковский', 'Мусоргский', 'Римский-Корсаков', 'Глинка'],
                correctIndex: 0,
                explanation: 'Пётр Ильич Чайковский — один из самых любимых русских композиторов.',
            },
            {
                type: QUESTION_TYPES.TRUE_FALSE,
                prompt: 'Модест Мусоргский был инженером и самоучкой в музыке.',
                correct: true,
                explanation: 'Верно! Он работал чиновником, а музыке учился сам и в «Могучей кучке».',
            },
            {
                type: QUESTION_TYPES.MULTIPLE_CHOICE,
                prompt: 'Рахманинов особенно славился как…',
                options: [
                    'пианист и композитор',
                    'только дирижёр',
                    'оперный певец',
                    'скрипач',
                ],
                correctIndex: 0,
                explanation: 'Его огромные руки помогали играть сложнейшие пассажи.',
                listenLink: { grade: 7, disk_num: 2, label: '7 класс, раздел 2' },
            },
            {
                type: QUESTION_TYPES.MULTIPLE_CHOICE,
                prompt: '«Князь Игорь» и «Половецкие пляски» — опера…',
                options: ['Бородина', 'Чайковского', 'Рубинштейна', 'Даргомыжского'],
                correctIndex: 0,
                explanation: 'Александр Бородин — химик и композитор.',
            },
            {
                type: QUESTION_TYPES.TRUE_FALSE,
                prompt: 'Прокофьев написал сказку «Петя и волк» для детей.',
                correct: true,
                explanation: 'Да! В ней каждый герой — свой инструмент оркестра.',
            },
            {
                type: QUESTION_TYPES.MULTIPLE_CHOICE,
                prompt: '«Вальс цветов» из балета «Щелкунчик» — музыка…',
                options: ['Чайковского', 'Глазунова', 'Скрябина', 'Лядова'],
                correctIndex: 0,
                explanation: 'Чайковский подарил миру волшебный балет.',
            },
            {
                type: QUESTION_TYPES.MULTIPLE_CHOICE,
                prompt: 'Стравинский стал знаменит после балета…',
                options: ['«Весна священная»', '«Лебединое озеро»', '«Жизель»', '«Спящая красавица»'],
                correctIndex: 0,
                explanation: 'Премьера 1913 года в Париже произвела фурор.',
            },
            {
                type: QUESTION_TYPES.MULTIPLE_CHOICE,
                prompt: 'Глазунов долго был директором…',
                options: [
                    'Ленинградской консерватории',
                    'Большого театра в Москве',
                    'Мариинского театра',
                    'Метрополитен-опера',
                ],
                correctIndex: 0,
                explanation: 'Александр Константинович Глазунов помогал молодым музыкантам.',
                listenLink: { grade: 7, disk_num: 1, label: '7 класс' },
            },
            {
                type: QUESTION_TYPES.MULTIPLE_CHOICE,
                prompt: 'Цикл «Детская» с пьесой «В углу» написал…',
                options: ['Мусоргский', 'Чайковский', 'Григ', 'Шуман'],
                correctIndex: 0,
                explanation: 'Мусоргский — в 4 классе Аудиопособия.',
                listenLink: { grade: 4, disk_num: 2, label: '4 класс, раздел 2' },
            },
            {
                type: QUESTION_TYPES.MULTIPLE_CHOICE,
                prompt: 'Рахманинов написал знаменитый…',
                options: [
                    'Вокализ (песня без слов)',
                    '«Реквием»',
                    '«Четыре сезона»',
                    '«Кармен»',
                ],
                correctIndex: 0,
                explanation: 'Вокализ — одна из самых узнаваемых мелодий XX века.',
                listenLink: { grade: 7, disk_num: 2, label: '7 класс' },
            },
        ],
    },
    {
        id: 'fact-or-fiction',
        title: 'Правда или музыкальная фантазия?',
        emoji: '🎭',
        tagline: 'Отличай факты от выдумки',
        duration: '~7 мин',
        color: '#e67e22',
        listenLink: null,
        questions: [
            {
                type: QUESTION_TYPES.TRUE_FALSE,
                prompt: 'Скрипка — самый маленький инструмент в симфоническом оркестре.',
                correct: false,
                explanation: 'Пикколо (маленькая флейта) звучит выше. Скрипка — из струнных, но не самая маленькая.',
            },
            {
                type: QUESTION_TYPES.TRUE_FALSE,
                prompt: 'Дирижёр управляет оркестром движениями рук.',
                correct: true,
                explanation: 'Верно! Дирижёр показывает темп, громкость и настроение.',
            },
            {
                type: QUESTION_TYPES.TRUE_FALSE,
                prompt: 'Балет — это только танец без музыки.',
                correct: false,
                explanation: 'Балет всегда идёт вместе с музыкой — иначе танцорам сложно двигаться в ритм.',
            },
            {
                type: QUESTION_TYPES.TRUE_FALSE,
                prompt: 'Моцарт написал свою первую симфонию ещё ребёнком.',
                correct: true,
                explanation: 'Он был музыкальным вундеркиндом — начал сочинять очень рано.',
            },
            {
                type: QUESTION_TYPES.TRUE_FALSE,
                prompt: 'В оркестре бывает только один барабан.',
                correct: false,
                explanation: 'Ударных много: литавры, треугольник, ксилофон, барабаны разных размеров.',
            },
            {
                type: QUESTION_TYPES.TRUE_FALSE,
                prompt: 'Опера — спектакль, где поют и играют музыканты.',
                correct: true,
                explanation: 'Певцы, хор и оркестр рассказывают историю на сцене.',
            },
            {
                type: QUESTION_TYPES.TRUE_FALSE,
                prompt: 'Бах никогда не был органистом в церкви.',
                correct: false,
                explanation: 'Наоборот! Бах много лет служил органистом в Лейпциге и других городах.',
            },
            {
                type: QUESTION_TYPES.TRUE_FALSE,
                prompt: 'Соната — музыкальное произведение для одного или нескольких инструментов.',
                correct: true,
                explanation: 'Часто для фортепиано или скрипки — несколько частей (частей-движений).',
            },
            {
                type: QUESTION_TYPES.TRUE_FALSE,
                prompt: 'Чайковский родился в Америке.',
                correct: false,
                explanation: 'Он родился в России, в Воткинске (ныне Удмуртия).',
            },
            {
                type: QUESTION_TYPES.TRUE_FALSE,
                prompt: 'Хор — это группа певцов, поющих вместе.',
                correct: true,
                explanation: 'В Аудиопособии ты часто слышишь хоры в опере и ораториях.',
            },
        ],
    },
    {
        id: 'bach-timeline',
        title: 'Путешествие с Бахом',
        emoji: '🎹',
        tagline: 'Расставь этапы жизни композитора',
        duration: '~5 мин',
        color: '#3d5c3a',
        listenLink: { grade: 4, disk_num: 1, label: '4 класс — Бах' },
        questions: [
            {
                type: QUESTION_TYPES.ORDER_EVENTS,
                prompt: 'Расположи события из жизни Иоганна Себастьяна Баха по порядку (сверху вниз — от раннего к позднему):',
                items: [
                    'Родился в большой музыкальной семье',
                    'Стал органистом в церкви',
                    'Жил и работал в Лейпциге',
                    'Написал много прелюдий и фуг',
                    'Его называют «отцом музыки»',
                ],
                correctOrder: [0, 1, 2, 3, 4],
                explanation:
                    'Бах жил в XVIII веке. Послушай его прелюдию в Аудиопособии — 4 класс.',
            },
        ],
    },
    {
        id: 'match-orchestra',
        title: 'Соедини пары',
        emoji: '🎻',
        tagline: 'Сопоставь музыку и факты',
        duration: '~6 мин',
        color: '#1abc9c',
        listenLink: null,
        questions: [
            {
                type: QUESTION_TYPES.MATCH_PAIRS,
                prompt: 'Соедини композитора и произведение из Аудиопособия:',
                left: ['Мусоргский', 'Чайковский', 'Бах', 'Рахманинов'],
                right: ['«Картинки с выставки»', '«Щелкунчик»', 'Прелюдия до мажор', 'Вокализ'],
                pairs: [
                    [0, 0],
                    [1, 1],
                    [2, 2],
                    [3, 3],
                ],
                explanation: 'Все эти записи есть в пособии — попробуй найти их на слух!',
            },
            {
                type: QUESTION_TYPES.MATCH_PAIRS,
                prompt: 'Соедини инструмент и его семейство:',
                left: ['Скрипка', 'Флейта', 'Тромбон', 'Литавры'],
                right: ['Струнные', 'Духовые', 'Медные духовые', 'Ударные'],
                pairs: [
                    [0, 0],
                    [1, 1],
                    [2, 2],
                    [3, 3],
                ],
                explanation: 'В оркестре инструменты сгруппированы по способу звукоизвлечения.',
            },
            {
                type: QUESTION_TYPES.MATCH_PAIRS,
                prompt: 'Соедини эпоху и пример композитора:',
                left: ['Барокко', 'Классицизм', 'Романтизм', 'XX век'],
                right: ['Бах', 'Моцарт', 'Чайковский', 'Стравинский'],
                pairs: [
                    [0, 0],
                    [1, 1],
                    [2, 2],
                    [3, 3],
                ],
                explanation: 'Эпохи сменяют друг друга — как главы в большой книге музыки.',
            },
        ],
    },
];

export const getQuizById = (id) => QUIZZES.find((q) => q.id === id);
